import { useContext } from "react";
import { menuContext } from "../context/MenuContext";

export const useMenuContext = () => useContext(menuContext);
